import { Injectable } from '@angular/core';
import { ISettings } from '@lsq-frontend/angular-shared/settings';
import { SpinnerStyle } from '@lsq-frontend/common-ui';
import { environment as angularEnvironment } from './environments/environment';
import shaFile from './app.sha.json';

@Injectable({ providedIn: 'root' })
export class AppSettings implements ISettings {
    public currentSha = shaFile.sha;
    // Dashboard-only settings.
    public defaultSearchLength = 15;
    public fileUploadMaximumSizeMb = 100;
    public historicalIneligiblesStartDate = new Date(2017, 11, 1);
    public maxNumberOfFilesPerInvoiceBatch = 100;
    public mobileUploadPollingInterval = 4000;
    public notificationPollingTimerInSeconds = angularEnvironment.notificationPollingTimerInSeconds;
    // ISettings implementation (common settings).
    public applicationName = 'Dashboard';
    public bugsnagApiKey =
        (angularEnvironment as any).bugsnagApiKey || 'ff62aaaa4f8f7bf4ae03a71bacb730b5';
    public cloudinaryApiKey = angularEnvironment.cloudinaryApiKey;
    public cognitoUserPoolId = angularEnvironment.cognitoUserPoolId;
    public cognitoClientId = angularEnvironment.cognitoClientId;
    public disableLoginPage = angularEnvironment.production;
    public downloadBackgroundTimeout = 10 * 1000;
    public environment = angularEnvironment.environment;
    public fabBlacklistedRoutePatterns = [/invoices\/upload/, /mobile-uploads/];
    public unauthorizedInterceptorBlacklist = [
        'CreateOpportunity',
        'GetCurrentUser',
        'GetAnalyticsReportUrl'
    ];
    public fileUploadUrl = 'https://api.cloudinary.com/v1_1/lsq/raw/upload';
    public googleAnalyticsId = angularEnvironment.googleAnalyticsId;
    public googlePlacesSearchRadius = 250; // In miles.
    public helpUrl = 'https://lsq.zendesk.com/hc/en-us';
    public idleModalLifespanInSeconds = angularEnvironment.idleModalLifespanInSeconds;
    public idleTimerInSeconds = angularEnvironment.idleTimerInSeconds;
    public imageUploadUrl = 'https://api.cloudinary.com/v1_1/lsq/image/upload';
    public internalGoogleAnalyticsId = angularEnvironment.internalGoogleAnalyticsId;
    public isDemo = !!(angularEnvironment as any).isDemo;
    public isInternalApp = false;
    public isManagement = false;
    public launchDarklyId = angularEnvironment.launchDarklyId;
    public managementHome = null;
    public maximumImageDownloadSize = 1000;
    public pageNotFoundButtonText = 'Go to Dashboard';
    public production = angularEnvironment.production;
    public spinnerType = SpinnerStyle.fadingRing;
    public warningImageDownloadSize = 200;
    public homeRedirectRouteBlacklist: RegExp[] = [
        /^\/financing\/invoices/,
        /^\/financing\/history/
    ];
    public httpApiDefaultServiceName = angularEnvironment.httpApiDefaultServiceName;
    public httpApiServiceNameUrlMap = angularEnvironment.httpApiServiceNameUrlMap;
    public healthCheckTimeoutMs = 20000;
    public marketingWebsiteUrl = 'https://www.lsq.com';
    public applicationUrl = 'https://www.lsq.com/contact-us';
    public lsqAdminCompanyKey = angularEnvironment.lsqAdminCompanyKey;
    public alanRuudCompanyKey = angularEnvironment.alanRuudCompanyKey;
}
